<template>
    <font-awesome-icon :icon="icon" fixed-width :spin="loading" :style="{color}" :title="title" />
</template>

<script>
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas, far)
dom.watch()

export default {
    components: { FontAwesomeIcon },
    props: {
        loading: { type: Boolean, default: false },
        icon: { type: [String, Array], default: null },
        title: { type: String, default: '' },
        color: { type: String, default: '' },
    }
}
</script>
